import { CustomerUser } from "../../customer/types/queries";

export enum CoreUserType {
  EXPERT = "Expert",
  CUSTOMER = "Customer",
}

export interface ExpertOutOfOfficePeriod {
  message: string;
  from: number;
  until: number;
}

export interface ExpertOutOfOffice extends Partial<ExpertOutOfOfficePeriod> {
  version?: number;
}

export interface ExpertUserAccount {
  firstName: string;
  lastName: string;
  emailAddress: string;
  orderQueueIds: string[];
  eezyCompanyIds: string[];
  authScopes: string[];
  registered: boolean;
  enabled?: boolean;
  outOfOffice?: ExpertOutOfOffice | null;
  version: number;
}

export interface ExpertUser {
  id: string;
  type: string;
  account: ExpertUserAccount;
}

// check this
export interface HrExpertUser {
  firstName: string;
  lastName: string;
  eezyCompanyNames: string[];
  id: string;
  outOfOffice?: ExpertOutOfOffice | null;
}

export type CoreUser = ExpertUser | CustomerUser;
